import { useFormContext, Controller } from 'react-hook-form';
import { RadioGroup, RadioGroupProps, ButtonBase, Box } from 'material-hu';
import { IconTypes } from 'src/types/icons';

type Props = RadioGroupProps & {
  options: { name: string; source: string }[];
  disabled?: boolean;
  closePopup?: (e) => void;
  selectorHandler?: (icon: { value: string; type: IconTypes }) => void;
};

function FormImageSelect({
  name,
  options,
  disabled,
  selectorHandler,
  closePopup,
  ...other
}: Props) {
  const { control } = useFormContext();

  const handleSelect = (e, field, option) => {
    field.onChange({
      value: option.source,
      type: IconTypes.IMAGE,
    });
    if (selectorHandler) {
      selectorHandler({
        value: option.source,
        type: IconTypes.IMAGE,
      });
    }
    closePopup(e);
  };

  return (
    <Controller
      render={({ field }) => (
        <RadioGroup
          {...other}
          {...field}
          sx={{
            flexDirection: 'row',
            backgroundColor: theme => theme.palette.background.default,
            height: 270,
            overflowY: 'auto',
            borderRadius: 1,
            opacity: disabled ? 0.5 : 1,
          }}
        >
          {options.map(option => {
            const isSelected = option.name === field.value;
            const borderWidth = isSelected ? 3 : 0;
            const imageHeight = 40 - borderWidth * 2;
            return (
              <ButtonBase
                onClick={e => handleSelect(e, field, option)}
                sx={{
                  m: 1,
                  borderRadius: 1,
                  borderWidth,
                  borderColor: theme => theme.palette.primary.main,
                  backgroundColor: theme =>
                    isSelected && theme.palette.primary.light,
                  ':hover': {
                    backgroundColor: theme => theme.palette.primary.light,
                  },
                  borderStyle: 'solid',
                  p: 1,
                }}
                key={option.name}
                disabled={disabled}
              >
                <Box
                  component="img"
                  src={option.source}
                  key={option.name}
                  alt="icon"
                  sx={{
                    width: imageHeight,
                    height: imageHeight,
                    objectFit: 'contain',
                  }}
                />
              </ButtonBase>
            );
          })}
        </RadioGroup>
      )}
      name={name}
      control={control}
    />
  );
}

export default FormImageSelect;
